import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	display: grid;
	grid-template-columns: 20px 1fr auto;
	gap: 10px;
	align-items: center;
	width: 340px;
	padding: 20px;
	background: #111314;
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	transition: background-color 0.3s ease;
	cursor: pointer;

	.icon {
		width: 20px;
		height: 20px;
		user-select: none;
		pointer-events: none;
		transition: filter 0.3s ease;
	}

	${Text} {
		color: #ffffff;
		transition: color 0.3s ease;
	}

	&:hover {
		background-color: #ffffff;

		${Text} {
			color: #000000;
		}

		.icon {
			filter: invert(100%);
		}
	}
`;

const StyledPrice = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	${Text} {
		font-weight: 700;
		font-size: 16px;
		color: #ffffff;
	}
`;

export { StyledContainer, StyledPrice };
